import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainSection() {
  const pains = ['Ese nudo en el pecho que aparece todos los domingos a la noche', 'Dormiste 8 horas y te levantás igual de cansado/a que antes', 'La mente sigue procesando el trabajo a las 2 AM aunque el cuerpo esté destruido', 'Dolor de cabeza y contractura cervical que ningún kinesiólogo termina de resolver', 'Pastillas para dormir que crean dependencia y no mejoran el descanso real'];
  return <section className="py-8 md:py-16 px-4 max-w-4xl mx-auto" data-id="element-264">
      <FadeIn data-id="element-265">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-3 md:mb-6 px-2 text-[#1f1b16]" data-id="element-266">
          ¿Cuántos días más vas a vivir así?
        </h2>

        <div className="text-sm md:text-xl text-[#6b6358] text-center mb-5 md:mb-12 space-y-2.5 md:space-y-4 max-w-3xl mx-auto font-medium" data-id="element-267">
          <p data-id="element-268">
            Ansiedad que no se va. Noches que no descansan. Un cuerpo que grita.
            Una mente que no para.
          </p>
          <p className="font-bold text-[#1f1b16] text-lg md:text-2xl mt-4 md:mt-8" data-id="element-269">
            No es debilidad. No es tu culpa.{' '}
            <span className="text-[#ef4444]" data-id="element-270">
              Es un sistema nervioso sin las herramientas correctas.
            </span>
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-16" data-id="element-271">
        {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-272">
            <motion.div whileHover={{
          scale: 1.02,
          backgroundColor: '#f5efe4'
        }} className="bg-[#faf7f2] border border-[#e7dfce] rounded-2xl p-4 md:p-6 flex gap-3 md:gap-4 items-start h-full transition-colors shadow-sm" data-id="element-273">
              <XCircle className="text-[#ef4444] shrink-0 mt-0.5 w-5 h-5 md:w-6 md:h-6" data-id="element-274" />
              <span className="text-sm md:text-lg text-[#1f1b16] leading-relaxed font-medium" data-id="element-275">
                {pain}
              </span>
            </motion.div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-276">
        <div className="text-center relative" data-id="element-277">
          <div className="absolute inset-0 bg-[#7c3aed]/10 blur-3xl rounded-full" data-id="element-278"></div>
          <motion.div animate={{
          y: [0, -5, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative z-10 inline-flex flex-col items-center" data-id="element-279">
            <Sparkles className="text-[#7c3aed] mb-2 md:mb-4 w-6 h-6 md:w-8 md:h-8" data-id="element-280" />
            <h3 className="text-2xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#5b21b6] via-[#7c3aed] to-[#a78bfa] drop-shadow-sm px-2" data-id="element-281">
              ¿Y si esta fuera la última noche que terminaste sin dormir?
            </h3>
          </motion.div>
        </div>
      </FadeIn>
    </section>;
}